import { loadHtml2Canvas } from 'utils/load-html2canvas'

/**
 * Captures an HTML element as a PNG and triggers a browser download.
 * Preloads Poppins weights before capture so the font renders correctly.
 */
export async function downloadChartAsPng(
  element: HTMLElement,
  filename: string,
): Promise<void> {
  await Promise.all([
    document.fonts.load('400 14px Poppins'),
    document.fonts.load('500 14px Poppins'),
    document.fonts.load('600 14px Poppins'),
  ])
  await document.fonts.ready

  const html2canvas = await loadHtml2Canvas()
  const canvas = await html2canvas(element, { scale: 2 })

  canvas.toBlob((blob) => {
    if (!blob) return
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `${filename}.png`
    link.click()
    URL.revokeObjectURL(link.href)
  })
}
